import React, { useState, useEffect, useMemo } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
import { getData, postData, putData } from "../../FetchNodeServices";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AlertMessages from "../Mains/Alerts";

const Setting = () => {
  const [isActivated, setActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState();
  const [accountStatus, setAccountStatus] = useState("");
  const [panelThrough, setPanelThrough] = useState(60);
  const [panelOption, setPanelOption] = useState("");
  const [addThrough, setAddThrough] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false); // State for showing success alert
  const [successMessage, setSuccessMessage] = useState(""); // State for success message content
  let navigate = useNavigate();
  const userRole = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userRole;
  const userId = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userId;
  const userName = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).fullName;
  const userEmail = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).email;

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleToggle = () => {
    setActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const customer = useSelector((state) => state.user.users[0]);
  const user = useMemo(() => customer?.userId || "", [customer]);
  const account = useMemo(() => customer?.accountId || "", [customer]);

  const AddThrough = {

    60: [{ id: '62,63', value: 'Add Panel User , Upload' }],
    61: [{ id: '64', value: 'API' }, { id: '65', value: 'Connect client database' }]

  }

  useEffect(() => {

    setAddThrough(panelThrough ? AddThrough[panelThrough] : [])

    if (panelThrough == 60) {
      setPanelOption("62,63")
    }
    else {
      setPanelOption(64)
    }

  }, [panelThrough])

  const handleUpdatePanelOptions = async () => {

    try {
      let result = await postData(`users/add-panel-via/${account}?addPanelVia=${panelThrough}&panelOption=${panelOption}`);
      if (result) {
        // setShowSuccessAlert(true);
        console.log("Response", result)
        // setSuccessMessage("Panel options updated successfully");
        setAlerts([{ variant: "success", heading: "Panel options updated successfully" }])
      } else {
        setAlerts([{ variant: "danger", heading: "Failed to update panel options" }]);
      }
    } catch (error) {
      setAlerts([{ variant: "danger", heading: "Failed to update panel options" }]);
    }
  }

  const fetchAccountStatus = async () => {
    try {
      let result = await getData("users/account-status/" + account);
      if (result) {
        setAccountStatus(result.accountStatus);
      }
    } catch (error) {
      setAlerts([{ variant: "danger", heading: "Failed to update status" }]);
    }
  };

  useEffect(() => {
    fetchAccountStatus();
  }, []);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  const handleResetPassword = async () => {
    try {
      let result = await postData("users/reset-password/" + user);
      if (result) {
        Toast.fire({
          icon: "success",
          title: "Mail sent successfully",
        });
      } else {
        Toast.fire({
          icon: "error",
          title: "Failed to send password reset mail",
        });
      }
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: "Failed to send password reset mail",
      });
    }
  };

  const handleStatusUpdate = async () => {
    try {
      let result = await putData(`users/update-account-status/${account}/${accountStatus}`);
      if (result) {
        setShowSuccessAlert(true);
        setSuccessMessage("Status updated successfully");

        setTimeout(() => {
          setShowSuccessAlert(false);
          setSuccessMessage("");
        }, 3000); // Hide alert after 3 seconds
      } else {
        setAlerts([{ variant: "danger", heading: "Failed to update status" }]);
      }
    } catch (error) {
      setAlerts([{ variant: "danger", heading: "Failed to update status" }]);
    }
  };

  const handleResetPasswordSubmit = async () => {
    if (newPassword !== confirmPassword) {
      Swal.fire({
        title: "Error!",
        text: "New password and confirm password do not match.",
        icon: "error",
      });
      return;
    }
    try {
      let result = await putData(`/users/update-password/${userId}?newPassword=${newPassword}`);

      if (result) {
        setShowSuccessAlert(true);
        setSuccessMessage("Password reset successfully");

        setNewPassword("");
        setConfirmPassword("");
        navigate("/");

        setTimeout(() => {
          setShowSuccessAlert(false);
          setSuccessMessage("");
        }, 3000); // Hide alert after 3 seconds
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to reset password.",
          icon: "error",
        });
      }
    } catch (error) {
      console.log("error in updating password");
    }
  };

  const handleClear = () => {
    setNewPassword("");
    setConfirmPassword("");
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />

        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <Link to="/manage-customer">
                <li>
                  <i className="bi bi-people"></i> Customer
                </li>
              </Link>
              <span className="breadcrumb_slash">/</span>
              <Link to="/manage-customer">
                <li>
                  <i className="bi bi-app-indicator mx-2"></i>Manage Customer
                </li>
              </Link>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i>Settings
              </li>
            </ul>

            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          {showSuccessAlert && (
            <div className="alert alert-success alert-dismissible fade show" role="alert">
              {successMessage}
              <button type="button" className="btn-close" onClick={() => setShowSuccessAlert(false)}></button>
            </div>
          )}

          {userRole === "S" ? (
            <>
              <div className="card p-3 border-light-subtle">
                <div><label htmlFor="" className="h5 fw-bold text-black">Account Setting</label></div>
                <div className="common_form p-3">
                  <div className="row">
                    <div className="col-lg-2  ">
                      <label htmlFor="">Account Status</label>
                    </div>
                    <div className="col-lg-2 d-flex gap-2 mb-4">
                      <select name="" value={accountStatus} id="" className="form-control" onChange={(event) => setAccountStatus(event.target.value)}>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                    <div className="col-lg-2 d-flex gap-2 mb-4">
                      <button className="btn btn-success" onClick={() => handleStatusUpdate()}>
                        Update
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 d-flex gap-5 mb-4 align-items-center">
                      <label htmlFor="">Set Password</label>
                      <button className="ms-2 btn btn-danger btn-lg" onClick={() => handleResetPassword()}>
                        reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card p-3 border-light-subtle mt-2">
                <div><label htmlFor="" className="h5 fw-bold text-black">Panel Management Setting</label></div>
                <div className="common_form p-3">
                  <div className="row">
                    <div className="col-lg-2">
                      <label htmlFor="">Add panel through</label>
                    </div>
                    <div className="col-lg-2 mb-4">
                      <select name="" value={panelThrough} id="" className="form-control" onChange={(event) => setPanelThrough(event.target.value)}>
                        <option value="60" >Capacity</option>
                        <option value="61" >Client</option>
                      </select>
                    </div>
                    <div className="col-lg-2 mb-4">
                      <select name="" id="" className="form-control" value={panelOption} onChange={(event) => setPanelOption(event.target.value)}>
                        {addThrough.map((item) => (
                          <option key={item.id} value={item.id}>{item.value}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-lg-2 mb-4">
                      <button className="btn btn-success" onClick={() => handleUpdatePanelOptions()}>
                        Save
                      </button>
                    </div></div>
                </div></div>

            </>
          ) : (
            <div className="card p-3 border-light-subtle">
              <div className="common_form p-3">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label for="">Name</label>
                      <input type="text" value={userName} className="form-control" placeholder="Enter Name" readOnly />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label for="">Email ID</label>
                      <input type="text" value={userEmail} className="form-control" placeholder="superadmin@capacity.com" readOnly />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label for="">New Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label for="">Confirm New Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Re-Enter New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="button_group">
                      <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => handleClear()}>
                        Clear Values
                      </button>
                    </div>
                    <div className="button_group">
                      <button type="button" className="btn btn-success px-4" onClick={() => handleResetPasswordSubmit()}>
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div >
    </div >
  );
};

export default Setting;
